import { render, staticRenderFns } from "./Swiper.vue?vue&type=template&id=a4487b5a"
import script from "./Swiper.vue?vue&type=script&lang=ts"
export * from "./Swiper.vue?vue&type=script&lang=ts"
import style0 from "./Swiper.vue?vue&type=style&index=0&id=a4487b5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports